<template>
<div>
    <div @click="close" class="overlay" :class="active ? 'active' : ''" />
    <aside class="drawer-nav">
      <div class="d-flex justify-content-between align-items-center">
        <Language mobile :languages="languages" />
        <div v-if="!user">
          <login-button mobile @click="handleClick">{{$t('login.signin')}}</login-button>
        </div>
        <i
          @click="close"
          :style="{color: color.primary}"
          class="mdi mdi-close ni-2x cursor-pointer mr-2"
        ></i>
      </div>
      <hr class="m-0" />
      <div v-if="user" class="px-3">
        <div v-if="!publicUser">
          <span class="avatar avatar-lg rounded-circle my-3">
            <img alt="profile" :src="image(user.photo)" />
          </span>
          <h4>{{user.name}}</h4>
          <h5 class="mb-3">{{user.email}}</h5>
        </div>
      </div>
      <hr class="m-0" />
      <nav>
        <template v-if="menuItems" >
          <template v-for="item in menuItems">
            <DrawerCustomGroup v-if="item.type === 'group' && !!item.status" :group="item" :key="item.id"/>
            <DrawerCustomOption v-if="item.type === 'option' && !!item.status" :option="item" :key="item.id" :user="user" :publicUser="publicUser"/>
          </template>
        </template>
        <template v-if="user">
          <a v-if="!publicUser && !menuItems" href="/app/dashboard" class="dropdown-item d-flex align-items-center">
            <i class="ni ni-collection"></i>
            <span class="ml-4">{{$t('common.my_plans')}}</span>
          </a>
          <!-- Glossário (backlog#342) -->
          <a v-if="!publicUser && glossaryLink" :href="glossaryLink" class="dropdown-item d-flex align-items-center nch--glossary-link">
            <i class="fas fa-book-open"></i>
            <span class="ml-4">{{$t('glossary.menu')}}</span>
          </a>
          <!-- Colocar o botão da gamificação aqui ou em outro lugar que fique depois de Meus Planos -->
          <a v-if="!publicUser && gamificationRules && gamificationRules.gamification_status" href="/app/gamification/score" class="dropdown-item">
            <i class="mdi mdi-google-controller"></i>
            <span class="ml-4">{{$t('common.gamification')}}</span>
          </a>
          <a v-if="!publicUser" href="/app/panel/profile" class="dropdown-item">
            <i class="mdi mdi-face-profile"></i>
            <span class="ml-4">{{$t('header.profile.title')}}</span>
          </a>
          <a v-if="!publicUser && showFinancial" href="/app/financial" class="dropdown-item">
            <i class="mdi mdi-credit-card"></i>
            <span class="ml-4">{{$t('common.financial')}}</span>
          </a>
          <a v-if="!publicUser && showTickets" href="/app/tickets" class="dropdown-item">
            <i class="mdi mdi-ticket-confirmation"></i>
            <span class="ml-4">{{$t('common.tickets')}}</span>
          </a>
        </template>
        <template v-if="!menuItems">
          <a href="/cart" class="dropdown-item">
            <i class="mdi mdi-cart"></i>
            <span class="ml-4">{{$t('common.cart')}}</span>
          </a>
          <a href="/plans" class="dropdown-item">
            <i class="fas fa-store"></i>
            <span class="ml-4">{{$t('common.plans')}}</span>
          </a>
        </template>
        <a v-if="user" href="#!" class="dropdown-item" @click="logoutUser">
          <i class="mdi mdi-login-variant"></i>
          <span class="ml-4">{{$t('header.profile.logout')}}</span>
        </a>
      </nav>
    </aside>
  </div>
</template>

<script>
import Language from "../NavbarComponents/NavbarLanguage";
import LoginButton from "../Common/LoginButton";
import DrawerCustomGroup from './Drawer/DrawerCustomGroup';
import DrawerCustomOption from './Drawer/DrawerCustomOption';
import image from '../../mixins/image';

export default {
  name: "Drawer",
  mixins: [image],
  components: {
    Language,
    LoginButton,
    DrawerCustomGroup,
    DrawerCustomOption
  },
  props: {
    user: Object,
    active: Boolean,
    publicUser: [Boolean, Number],
    languages: {
      type: Array,
      required: true
    },
    menuItems: Object | Array,
    loginSocial: Array,
    gamificationRules: {
      type: Object,
      required: false
    },
    /** Glossário (backlog#342): endereço do link, ou null */
    glossaryLink: {
      type: String,
      default: null
    }
  },
  computed: {
    color() {
      return this.$store.getters.NAV_COLOR;
    },
    showTickets() {
      return (
        Object.values(this.menuItems).findIndex(({ href, show }) => {
          return href === "/app/tickets" && show;
        }) > -1
      );
    },
    /**
     * Faturamento visível? Segue o menu do servidor (LayoutsComposer), que já
     * aplica a flag God "Mostrar faturamento para o aluno" (backlog#411).
     */
    showFinancial() {
      return (
        Object.values(this.menuItems).findIndex(({ href, show }) => {
          return href === "/app/financial" && show;
        }) > -1
      );
    }
  },
  methods: {
    close() {
      this.$emit("closeDrawer");
    },
    handleClick() {
      this.$emit("closeDrawer");
      this.$store.commit("DIALOG_SHOW", {
        redirect: "/app/dashboard",
        social: this.loginSocial
      });
    },
    setTarget(target) {
      if (target) return "_blank";
    },
    logoutUser() {
      this.$loading.show();

      window.axios
        .post("/logout")
        .then(response => {
          setTimeout(() => {
            localStorage.removeItem("nochalks_token");
            location.href = "/login";
          }, 150);
        })
        .catch(error => {
          setTimeout(() => {
            this.$notify({
              type: "danger",
              message: this.$t("login.messages.error")
            });
          }, 150);
        });
    }
  }
};
</script>

<style lang="scss">
// Variables
$transition1: 0.3s all;
$color-background: #f1f1f1;
$color-overlay: rgba(0, 0, 0, 0.3);
$color-black: #3e3e3e;

aside.drawer-nav {
  transition: $transition1;
  max-width: 300px;
  background: #fff;
  position: fixed;
  height: 100vh;
  transform: translateX(-100%);
  overflow: auto;
  z-index: 80;
  width: 100%;
  top: 0;
  left: 0;

  nav {
    display: flex;
    flex-direction: column;
  }
}

.dropdown-item {
  font-size: 1.1rem;
  display: block;
  padding: 15px 20px;
}


.drawerActive {
  .drawer-nav {
    transform: translateX(0);
  }

  .hamburger-icon__stripe-top,
  .hamburger-icon__stripe-middle {
    transform: rotate(45deg);
  }

  .hamburger-icon__stripe-bottom {
    transform: rotate(-45deg);
  }
}

.overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 79;
  cursor: pointer;

  &.active {
    display: block !important;
  }
}
</style>
<style scoped>
.mdi-google-controller {
  font-size: 20px;
  margin-right: -6px;
}
</style>
